import QRCode from 'qrcode';
import type { Asset } from '../types/api';

function escapeHtml(s: string) {
  const map: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  return s.replace(/[&<>"']/g, (c) => map[c]);
}

// Opens a small pop-up with a printable QR label for the asset (§ Perry:
// "QR/barcode labels for physical asset tags"). The code encodes a direct
// link to the asset's detail page - if the scanning device isn't signed in,
// RequireAuth already preserves the intended destination through the login
// redirect (see auth/RequireAuth.tsx + LoginPage.tsx), so it lands on the
// right asset once logged in rather than just the homepage.
//
// Generated entirely client-side (the `qrcode` package, no network call) -
// deliberately not using a third-party "QR image" web service, since that
// would leak every asset's URL to an outside party on every label print and
// wouldn't work if the server ever lost outbound internet access.
export async function printAssetLabel(asset: Asset) {
  const url = `${window.location.origin}/assets/${asset.id}`;
  const qrDataUrl = await QRCode.toDataURL(url, { width: 240, margin: 1 });

  const itemName = asset.orderLine?.customerCatalogItem?.name ?? 'Asset';
  const win = window.open('', '_blank', 'width=380,height=520');
  if (!win) {
    throw new Error('Pop-up blocked - allow pop-ups for this site to print a label.');
  }

  win.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${escapeHtml(itemName)} - label</title>
        <style>
          body { font-family: -apple-system, BlinkMacSystemFont, sans-serif; text-align: center; padding: 20px; margin: 0; }
          img { width: 200px; height: 200px; }
          h2 { margin: 12px 0 2px; font-size: 15px; }
          p { margin: 1px 0; font-size: 12px; color: #555; }
        </style>
      </head>
      <body>
        <img src="${qrDataUrl}" alt="QR code" />
        <h2>${escapeHtml(itemName)}</h2>
        ${asset.serialNumber ? `<p>Serial: ${escapeHtml(asset.serialNumber)}</p>` : ''}
        ${asset.currentSite ? `<p>${escapeHtml(asset.currentSite.name)}</p>` : ''}
        <script>window.onload = function () { window.print(); };</script>
      </body>
    </html>
  `);
  win.document.close();
}
